import { useEffect, useState } from 'react'
import Trash from '../../../../assets/icons/trash'
import DeleteModal from '../DeleteModal'
import { TSummaryQuestion } from '../QuestionsSummary/types'
import { Container } from './styles'

type TStatus = 'right' | 'wrong' | 'pending'

interface IProps {
  data: TSummaryQuestion
  position: number

  onDelete(question: TSummaryQuestion): void
  onClick?(question: TSummaryQuestion): void
}

const Question = (props: IProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [text, setText] = useState('')

  const status = ((): TStatus => {
    const { hit, answerDate } = props.data.answer

    if (!answerDate) return 'pending'
    if (hit) return 'right'
    return 'wrong'
  })()

  useEffect(() => {
    if (props.data.text) {
      setText(props.data.text.replace(/\\[n|r|t]/g, '<br />'))
    }
  }, [props.data.text])

  return (
    <>
      <Container>
        <div className="result" data-status={status}>
          {status === 'right' && 'Resposta certa'}
          {status === 'wrong' && 'Resposta errada'}
          {status === 'pending' && 'Pendente'}
        </div>
        <button className="clickable-area" onClick={() => props.onClick(props.data)}>
          <p className="short-text">
            <b>Questão {props.data.questionNumber || props.position} - </b>{' '}
            <span
              ref={(node) => {
                if (node) {
                  node.innerHTML = node.textContent
                }
              }}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </p>
        </button>
        <div className="group-1">
          <div className="badges">
            {props.data.hierarchies[0]?.name && <p>{props.data.hierarchies[0]?.name}</p>}
            <p>{props.data.code}</p>
          </div>

          <button className="delete-mobile" onClick={() => setIsOpen(true)}>
            Excluir
          </button>
          <button className="delete-desktop" onClick={() => setIsOpen(true)}>
            <Trash width={30} height={30} />
          </button>
        </div>
      </Container>
      <DeleteModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        question={props.data}
        position={props.position}
        onDelete={props.onDelete}
      />
    </>
  )
}

export default Question
